import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { cn } from "../../utils/utils";

const RadioGroup = ({ children, ...props }) => (
  <RadioGroupPrimitive.Root className="flex flex-col gap-2" {...props}>
    {children}
  </RadioGroupPrimitive.Root>
);

const RadioGroupItem = ({ id, value, label }) => (
  <div className="flex items-center gap-2">
    <RadioGroupPrimitive.Item
      value={value}
      id={id}
      className={cn(
        "bg-white w-6 h-6 rounded-full shadow-md",
        "hover:bg-violet-100 focus:outline-none focus:ring-2 focus:ring-black"
      )}
    >
      <RadioGroupPrimitive.Indicator className="flex items-center justify-center w-full h-full relative">
        <div className="w-[11px] h-[11px] bg-violet-800 rounded-full" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
    <label htmlFor={id} className="text-white text-sm pl-2">
      {label}
    </label>
  </div>
);

export { RadioGroup, RadioGroupItem };
